module.exports = __webpack_public_path__ + "static/media/defaultImage.200e17a1.png";